var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-custom-scrollbar',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.removeMobileMnue),expression:"removeMobileMnue"}],staticClass:"navbar navbar-vertical fixed-left navbar-expand-md navbar-light",class:_vm.isActive ? 'active' : '',attrs:{"settings":_vm.settings}},[_c('div',{staticClass:"container-fluid"},[_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#sidebarCollapse","aria-controls":"sidebarCollapse","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":_vm.toggleMobile}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#sidebarCollapse","aria-controls":"sidebarCollapse","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":function($event){_vm.$parent.showMobileNave = !_vm.$parent.showMobileNave
        _vm.$parent.showMobileMnue = false}}},[(_vm.$checkRole('profile_edit'))?_c('router-link',{staticClass:"navbar-user-link nav-icon dropdown-toggle w-100",attrs:{"to":'/profile'}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-user"}),_vm._v(" "+_vm._s(_vm.$user.name)+" ")])]):_vm._e(),(!_vm.$checkRole('profile_edit'))?_c('div',{staticClass:"navbar-user-link nav-icon dropdown-toggle w-100"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-user"}),_vm._v(" "+_vm._s(_vm.$user.name)+" ")])]):_vm._e()],1),_c('div',{staticClass:"form-group has-search search-sidebar-style"},[_c('i',{staticClass:"fa fa-search form-control-feedback"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchValue),expression:"searchValue"},{name:"click-outside",rawName:"v-click-outside",value:(_vm.removeSearch),expression:"removeSearch"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"بحث"},domProps:{"value":(_vm.searchValue)},on:{"keyup":function($event){return _vm.searchLink()},"focus":function($event){return _vm.searchLink()},"input":function($event){if($event.target.composing)return;_vm.searchValue=$event.target.value}}})]),_c('vue-custom-scrollbar',{staticClass:"collapse navbar-collapse",class:{ show: _vm.$parent.showMobileMnue },attrs:{"settings":_vm.settings2,"id":"sidebarCollapse"}},[(_vm.showSearchStat && _vm.selectedLinks.length != 0)?_c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.selectedLinks),function(link,index){return _c('singleItem',{key:index,attrs:{"to":link.link.substring(1),"icon":'far fa-file',"headname":link.name}})}),1):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('ul',{staticClass:"navbar-nav"},[_c('singleItem',{attrs:{"to":'',"icon":'far fa-tachometer-alt-fastest',"headname":_vm.$t('sidebar.dashboard')}})],1):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('hr',{staticClass:"navbar-divider my-3"}):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('ul',{staticClass:"navbar-nav"},[(
            _vm.$checkMultiRoles([
              'customers_show',
              'quotations_show',
              'invoices_show',
              'sale_returns_show',
              'orders_show'
            ])
          )?_c('multiItem',{attrs:{"icon":'far fa-chart-line',"headname":_vm.$t('sidebar.sales'),"items":[
            {
              name: _vm.$t('sidebar.customers'),
              link: '/customers',
              role: _vm.$checkRole('customers_show')
            },
            {
              name: _vm.$t('sidebar.estimates'),
              link: '/quotations',
              role: _vm.$checkRole('quotations_show')
            },
            {
              name: _vm.$t('sidebar.salesInvoices'),
              link: '/invoices',
              role: _vm.$checkRole('invoices_show')
            },
            {
              name: _vm.$t('sidebar.salesReturns'),
              link: '/saleReturns',
              role: _vm.$checkRole('sale_returns_show')
            },
            {
              name: _vm.$t('sidebar.saleOrders'),
              link: '/orders',
              role: _vm.$checkRole('orders_show')
            }
          ]}}):_vm._e(),(_vm.$checkMultiRoles(['purchase_returns_show', 'bills_show', 'suppliers_show']))?_c('multiItem',{attrs:{"icon":'far fa-shopping-cart',"headname":_vm.$t('sidebar.purchases'),"items":[
            {
              name: _vm.$t('sidebar.suppliers'),
              link: '/suppliers',
              role: _vm.$checkRole('suppliers_show')
            },
            {
              name: _vm.$t('sidebar.bills'),
              link: '/bills',
              role: _vm.$checkRole('bills_show')
            },
            {
              name: _vm.$t('sidebar.purchaseReturns'),
              link: '/purchaseReturns',
              role: _vm.$checkRole('purchase_returns_show')
            }
          ]}}):_vm._e(),(
            _vm.$checkMultiRoles([
              'safes_show',
              'safes_deposits_show',
              'safes_withdrawals_show',
              'safes_transfers_show',
              'bank_accounts_show',
              'sales_payments_show',
              'purchase_payments_show',
              'expenses_show',
              'sales_discounts_show',
              'purchase_discounts_show'
            ])
          )?_c('multiItem',{attrs:{"icon":'far fa-treasure-chest',"headname":_vm.$t('sidebar.Safes'),"items":[
            {
              name: _vm.$t('sidebar.lockersList'),
              link: '/safes',
              role: _vm.$checkRole('safes_show')
            },
            {
              name: _vm.$t('sidebar.bankAccounts'),
              link: '/bankAccounts',
              role: _vm.$checkRole('bank_accounts_show')
            },
            {
              name: _vm.$t('sidebar.salePayments'),
              link: '/salesPayments',
              role: _vm.$checkRole('sales_payments_show')
            },
            {
              name: _vm.$t('sidebar.purchasePayments'),
              link: '/purchasePayments',
              role: _vm.$checkRole('purchase_payments_show')
            },
            {
              name: _vm.$t('sidebar.Expenses'),
              link: '/expenses',
              role: _vm.$checkRole('expenses_show')
            },
            {
              name: 'ايرادات',
              link: '/incomes',
              role: _vm.$checkRole('expenses_show')
            },

            {
              name: _vm.$t('sidebar.Deposits'),
              link: '/safesDeposits',
              role: _vm.$checkRole('safes_deposits_show')
            },
            {
              name: _vm.$t('sidebar.Withdrawals'),
              link: '/safesWithdrawals',
              role: _vm.$checkRole('safes_withdrawals_show')
            },
            {
              name: _vm.$t('sidebar.Transfers'),
              link: '/safesTransfers',
              role: _vm.$checkRole('safes_transfers_show')
            }
          ]}}):_vm._e(),(
            _vm.$checkMultiRoles([
              'stores_show',
              'products_show',
              'stores_deposits_show',
              'stores_withdrawals_show',
              'stores_transfers_show'
            ])
          )?_c('multiItem',{attrs:{"icon":'far fa-store-alt',"headname":_vm.$t('sidebar.stores'),"items":[
            {
              name: _vm.$t('sidebar.storesList'),
              link: '/stores',
              role: _vm.$checkRole('stores_show')
            },
            {
              name: _vm.$t('sidebar.productsAndServices'),
              link: '/products',
              role: _vm.$checkRole('products_show')
            },
            {
              name: _vm.$t('sidebar.Deposits'),
              link: '/storesDeposits',
              role: _vm.$checkRole('stores_deposits_show')
            },
            {
              name: _vm.$t('sidebar.Withdrawals'),
              link: '/storesWithdrawals',
              role: _vm.$checkRole('stores_withdrawals_show')
            },
            {
              name: _vm.$t('sidebar.Transfers'),
              link: '/storesTransfers',
              role: _vm.$checkRole('stores_transfers_show')
            },
            {
              name: 'تحميل المخازن',
              link: '/storesOrders',
              role: _vm.$checkRole('stores_orders_show')
            }
          ]}}):_vm._e(),(_vm.$checkMultiRoles(['sales_cheques_show', 'purchase_cheques_show']))?_c('multiItem',{attrs:{"icon":'far fa-money-check-alt',"headname":_vm.$t('sidebar.Checks'),"items":[
            {
              name: _vm.$t('sidebar.salesCheques'),
              link: '/salesCheques',
              role: _vm.$checkRole('sales_cheques_show')
            },
            {
              name: _vm.$t('sidebar.purchaseCheques'),
              link: '/purchaseCheques',
              role: _vm.$checkRole('purchase_cheques_show')
            }
          ]}}):_vm._e(),(_vm.$checkMultiRoles(['sales_discounts_show', 'purchase_discounts_show']))?_c('multiItem',{attrs:{"icon":'far fa-badge-percent',"headname":_vm.$t('sidebar.Discounts'),"items":[
            {
              name: _vm.$t('sidebar.salesDiscounts'),
              link: '/salesDiscounts',
              role: _vm.$checkRole('sales_discounts_show')
            },
            {
              name: _vm.$t('sidebar.purchaseDiscounts'),
              link: '/purchaseDiscounts',
              role: _vm.$checkRole('purchase_discounts_show')
            }
          ]}}):_vm._e(),(
            _vm.$checkMultiRoles([
              'employees_show',
              'employees_Salaries_show',
              'employees_Salaries_show',
              'employees_incentives_show',
              'employees_deductions_show',
              'employees_withdrawals_show'
            ])
          )?_c('multiItem',{attrs:{"icon":'far fa-user-chart',"headname":_vm.$t('sidebar.showStaff'),"items":[
            {
              name: _vm.$t('sidebar.employeesList'),
              link: '/employees',
              role: _vm.$checkRole('employees_show')
            },
            {
              name: _vm.$t('sidebar.employeeSalaries'),
              link: '/employeesSalaries',
              role: _vm.$checkRole('employees_Salaries_show')
            },
            {
              name: _vm.$t('sidebar.EmployeeIncentives'),
              link: '/employeesIncentives',
              role: _vm.$checkRole('employees_incentives_show')
            },
            {
              name: _vm.$t('sidebar.EmployeeDiscounts'),
              link: '/employeesDeductions',
              role: _vm.$checkRole('employees_deductions_show')
            },
            {
              name: _vm.$t('sidebar.StaffDraws'),
              link: '/employeesWithdrawals',
              role: _vm.$checkRole('employees_withdrawals_show')
            }
          ]}}):_vm._e(),(
            _vm.$checkMultiRoles([
              'partners_show',
              'partners_deposits_show',
              'partners_withdrawals_show',
              'partners_settlements_show',
              'partners_profits_show'
            ])
          )?_c('multiItem',{attrs:{"icon":'far fa-handshake',"headname":_vm.$t('sidebar.partners'),"items":[
            {
              name: _vm.$t('sidebar.partners'),
              link: '/partners',
              role: _vm.$checkRole('partners_show')
            },
            {
              name: _vm.$t('sidebar.partnersDeposits'),
              link: '/partnersDeposits',
              role: _vm.$checkRole('partners_deposits_show')
            },
            {
              name: _vm.$t('sidebar.WithdrawalOfPartners'),
              link: '/partnersWithdrawals',
              role: _vm.$checkRole('partners_withdrawals_show')
            },
            {
              name: _vm.$t('sidebar.partnersSettlement'),
              link: '/partnersSettlements',
              role: _vm.$checkRole('partners_settlements_show')
            },
            {
              name: _vm.$t('sidebar.DivideTheProfits'),
              link: '/partnersProfits',
              role: _vm.$checkRole('partners_profits_show')
            }
          ]}}):_vm._e(),(_vm.$checkRole('capitals_show'))?_c('singleItem',{attrs:{"to":'capitals',"icon":'far fa-building',"headname":"الأصول الثابتة"}}):_vm._e(),(_vm.$checkMultiRoles(['manufacturing_models_show', 'manufacturing_operations_show']))?_c('multiItem',{attrs:{"icon":'far fa-hammer',"headname":_vm.$t('sidebar.ManufacturingProcesses'),"items":[
            {
              name: _vm.$t('sidebar.ManufacturingModels'),
              link: '/manufacturingModels',
              role: _vm.$checkRole('manufacturing_models_show')
            },
            {
              name: _vm.$t('sidebar.OperationsList'),
              link: '/manufacturingOperations',
              role: _vm.$checkRole('manufacturing_operations_show')
            },
            {
              name: _vm.$t('sidebar.materialDeposit'),
              link: '/manufacturingDeposits',
              role: _vm.$checkRole('manufacturing_operations_show')
            },
            {
              name: _vm.$t('sidebar.productsWithdrawal'),
              link: '/manufacturingWithdrawals',
              role: _vm.$checkRole('manufacturing_operations_show')
            }
          ]}}):_vm._e(),(_vm.$checkMultiRoles(['cities_show']))?_c('multiItem',{attrs:{"icon":'far fa-shipping-fast',"headname":_vm.$t('sidebar.Shipping'),"items":[
            {
              name: _vm.$t('sidebar.freightForwarders'),
              link: '/deliveries',
              role: true
            },
            {
              name: 'قائمة الدخل',
              link: '/cities',
              role: _vm.$checkRole('cities_show')
            },
            {
              name: _vm.$t('sidebar.pickupLocations'),
              link: '/pickupLocations',
              role: _vm.$checkRole('cities_show')
            },
            {
              name: _vm.$t('sidebar.shippingOperations'),
              link: '/shippingOperations',
              role: _vm.$checkRole('cities_show')
            },
            {
              name: _vm.$t('sidebar.shippingAddresses'),
              link: '/shippingAddresses',
              role: _vm.$checkRole('cities_show')
            }
          ]}}):_vm._e(),(_vm.$checkMultiRoles(['point_of_sales_show']))?_c('singleItem',{attrs:{"to":'pointOfSales',"icon":'far fa-cash-register',"headname":_vm.$t('sidebar.pointsOfSale')}}):_vm._e()],1):_vm._e(),(_vm.$checkRole('reports_show') && (!_vm.showSearchStat || _vm.selectedLinks.length == 0))?_c('ul',{staticClass:"navbar-nav"},[(_vm.$checkRole('reports_show'))?_c('singleItem',{attrs:{"to":'mainReport',"icon":'far fa-chart-bar',"headname":_vm.$t('sidebar.Reports')}}):_vm._e(),(_vm.$checkRole('accounting_show'))?_c('multiItem',{attrs:{"icon":'far fa-balance-scale',"headname":_vm.$t('sidebar.Accounting'),"items":[
            {
              name: _vm.$t('sidebar.ProfitsAndLosses'),
              link: '/profitsAndLosses',
              role: true
            },
            {
              name: _vm.$t('sidebar.BalanceSheet'),
              link: '/totalReport',
              role: true
            },
            {
              name: _vm.$t('sidebar.ProfitsByInvoices'),
              link: '/profitsByInvoices',
              role: true
            },
            {
              name: _vm.$t('sidebar.dailyRestrictions'),
              link: '/dailyRestrictions',
              role: true
            }
          ]}}):_vm._e()],1):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('div',{staticClass:"mt-auto"}):_vm._e(),(!_vm.showSearchStat || _vm.selectedLinks.length == 0)?_c('ul',{staticClass:"navbar-nav"},[(_vm.$checkRole('options_show'))?_c('singleItem',{attrs:{"to":'options',"icon":'far fa-cog',"headname":_vm.$t('sidebar.settings')}}):_vm._e(),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link c-pointer",on:{"click":_vm.$logout}},[_c('i',{staticClass:"far fa-sign-out"}),_vm._v(" "+_vm._s(_vm.$t('sidebar.logout'))+" ")])])],1):_vm._e()])],1),_c('div',{staticClass:"sidebar-user"},[_c('router-link',{attrs:{"to":'/profile'}},[_c('div',{staticClass:"sidebar-user-flex"},[_c('div',{staticClass:"sidebar-user-img",style:(_vm.shownImage ? 'background-image: ' + _vm.shownImage + ';' : '')}),_c('div',{staticClass:"sidebar-user-info"},[_c('h3',[_vm._v(_vm._s(_vm.$user.name))]),_c('p',[_vm._v(_vm._s(_vm.$user.email))])])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }